import { useEffect, useState } from "react";
import { browserStorage } from "~/libs/localforage";
import { ViewPreferenceContext, initialState } from "./view-preference-context";
import type { FC, ReactNode } from "react";
import { FILE_VIEW_PREFERENCE_KEYS } from "~served/configs";
interface ViewPreferenceProviderProps {
  children: ReactNode;
}
export const ViewPreferenceProvider: FC<ViewPreferenceProviderProps> = ({
  children
}) => {
  const [fileViewPreference, setFileViewPreference] = useState(initialState.fileViewPreference);
  const handleChangeViewPreference = async (val: FILE_VIEW_PREFERENCE_KEYS) => {
    setFileViewPreference(val);
    await browserStorage.fileViewPreference.set(val);
  };
  useEffect(() => {
    browserStorage.fileViewPreference.get().then(r => {
      setFileViewPreference(r as unknown as FILE_VIEW_PREFERENCE_KEYS);
    }).catch(err => console.log({
      err
    }));
  }, []);
  return <ViewPreferenceContext.Provider value={{
    fileViewPreference,
    handleChangeViewPreference
  }} data-sentry-element="unknown" data-sentry-component="ViewPreferenceProvider" data-sentry-source-file="view-preference-provider.tsx">
			{children}
		</ViewPreferenceContext.Provider>;
};